module.exports = __webpack_public_path__ + "static/media/next.daf2d13a.svg";